import { ChangeDetectionStrategy, Component, effect, input, OnInit, output, OutputEmitterRef, signal } from '@angular/core';
import { IconComponent } from '../icon';

export type DrawerOrigin = 'left' | 'right';

@Component({
  selector: 'spx-side-drawer',
  templateUrl: './side-drawer.component.html',
  styleUrls: ['./side-drawer.component.scss'],
  host: { '[class.expanded]': 'isExpanded()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class SideDrawerComponent implements OnInit {
  public displayClose = input<boolean>(true);
  public title = input<string>();
  public transitionOrigin = input<DrawerOrigin>('left');
  disableBackgroundScroll = input<boolean>(true);
  expanded = input<boolean>(false);
  public isExpanded = signal<boolean>(false);
  public animate = signal<boolean>(false);
  public sideDrawerClosed: OutputEmitterRef<void> = output();

  constructor() {
    effect(() => {
      const exp = this.expanded();
      if (exp) {
        this.open();
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.animate.set(true);
    });
  }

  open(): void {
    this.isExpanded.set(true);

    if (this.disableBackgroundScroll()) {
      document.body.style.overflow = 'hidden';
    }
  }

  close(): void {
    this.isExpanded.set(false);
    this.sideDrawerClosed.emit();

    if (this.disableBackgroundScroll()) {
      document.body.style.overflow = '';
    }
  }
}
